import script from "./VSnowfall.vue?vue&type=script&setup=true&lang=ts"
export * from "./VSnowfall.vue?vue&type=script&setup=true&lang=ts"

import "./VSnowfall.vue?vue&type=style&index=0&id=45c9e05a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c9e05a"]])

export default __exports__